import gsap from "gsap"
import ScrollTrigger from 'gsap/ScrollTrigger'
import CustomEase from 'gsap/CustomEase'

gsap.registerPlugin(ScrollTrigger, CustomEase)

function initTestimonialsSectionAnimation() {
    const testimonialsSection = document.querySelector('.testimonials')
    
    if (!testimonialsSection) return
    
    const customEase = CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
    
    const slides = testimonialsSection.querySelectorAll('.swiper-slide')
    const swiperMenu = testimonialsSection.querySelector('.swiper-menu')
    
    if (slides.length > 0) {
        gsap.set(slides, { autoAlpha: 0, y: 80, scale: 0.9 })
    }
    
    if (swiperMenu) {
        const menuElements = [
            swiperMenu.querySelector('.swiper-prev'),
            swiperMenu.querySelector('.swiper-dots'),
            swiperMenu.querySelector('.swiper-next')
        ].filter(el => el !== null)
        
        gsap.set(menuElements, { autoAlpha: 0, y: 30 })
    }
    
    if (slides.length > 0) {
        slides.forEach((slide, index) => {
            gsap.fromTo(slide,
                {
                    autoAlpha: 0,
                    y: 80,
                    scale: 0.9
                },
                {
                    autoAlpha: 1,
                    y: 0,
                    scale: 1,
                    duration: 1,
                    delay: index * 0.12,
                    ease: customEase,
                    scrollTrigger: {
                        trigger: '.testimonials__container__content',
                        start: 'clamp(top 85%)',
                        once: true
                    }
                }
            )
        })
    }
    
    if (swiperMenu) {
        const menuElements = [
            swiperMenu.querySelector('.swiper-prev'),
            swiperMenu.querySelector('.swiper-dots'),
            swiperMenu.querySelector('.swiper-next')
        ].filter(el => el !== null)
        
        gsap.fromTo(menuElements,
            {
                autoAlpha: 0,
                y: 30
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 0.8,
                stagger: 0.1,
                ease: customEase,
                scrollTrigger: {
                    trigger: '.testimonials__container__content',
                    start: 'clamp(top 85%)',
                    once: true
                },
                delay: 0.4
            }
        )
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialsSectionAnimation)
} else {
    initTestimonialsSectionAnimation()
}